import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=29d55f7b&scoped=true&lang=pug"
import script from "./NotificationBell.vue?vue&type=script&lang=ts"
export * from "./NotificationBell.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=29d55f7b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d55f7b",
  null
  
)

export default component.exports